import React, { useState, useEffect } from "react";
import { CiCirclePlus } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../Components/Sidebar";

import { useDispatch, useSelector } from "react-redux";
import {
  fetchHelpDeskData,
  updateHelpDeskData,
} from "../../redux/actions/ITServicesAction";
import PageComponent from "../../Components/PageComponent";

function HelpDesk() {
  const navigate = useNavigate();
  const [selectedFile, setSelectedFile] = useState(null);

  const dispatch = useDispatch();
  const {
    data: helpDeskData,
    loading,
    error,
  } = useSelector((state) => state.ITServices.helpDesk);

  const [id, setId] = useState(null);
  const [introduction, setIntroduction] = useState("");
  const [fileUrl, setFileUrl] = useState("");
  const [linkName, setLinkName] = useState("");
  const [linkUrl, setLinkUrl] = useState("");

  useEffect(() => {
    dispatch(fetchHelpDeskData());
  }, [dispatch]);
  console.log("id", id);

  useEffect(() => {
    if (helpDeskData) {
      setId(helpDeskData.id || null);
      setIntroduction(helpDeskData.introduction || "");
      setFileUrl(helpDeskData.file_url || ""); // Set file URL from database

      // The link (name + url) is stored inside the links JSON (first item)
      let parsedLinks = [];
      if (helpDeskData.links) {
        try {
          parsedLinks =
            typeof helpDeskData.links === "string"
              ? JSON.parse(helpDeskData.links)
              : helpDeskData.links;
        } catch (error) {
          console.error("Invalid links JSON:", error);
          parsedLinks = [];
        }
      }
      const firstLink = Array.isArray(parsedLinks) ? parsedLinks[0] : null;
      setLinkName(firstLink?.title || "");
      setLinkUrl(firstLink?.url || "");
    }
  }, [helpDeskData]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      setFileUrl(URL.createObjectURL(file)); // Display the selected file
    }
  };

  const handleFileRemove = () => {
    setSelectedFile(null);
    setFileUrl(""); // Remove the displayed file
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    if (!id) {
      alert("ID is missing. Unable to update introduction and links.");
      return;
    }

    const formData = new FormData();
    formData.append("introduction", introduction);
    // Store the single link (name + url) inside the links JSON
    const linksPayload = linkUrl.trim()
      ? [{ title: linkName.trim(), url: linkUrl.trim() }]
      : [];
    formData.append("links", JSON.stringify(linksPayload));

    for (let [key, value] of formData.entries()) {
      console.log(`${key}:`, value);
    }

    try {
      await dispatch(updateHelpDeskData(id, formData));

      dispatch(fetchHelpDeskData());
    } catch (error) {
      console.error("Error updating data:", error.response || error.message);
      alert("Failed to update data. Please try again.");
    }
  };

  return (
    <><PageComponent>
    <div className="flex w-screen h-screen overflow-x-hidden bg-[#F8F7FA]">
      <div className="fixed top-0 left-0 w-64 h-full overflow-y-auto bg-white shadow-md">
        <Sidebar />
      </div>

      <div className="flex-1 p-6 ml-64">
        <div className="flex items-center space-x-2 text-3xl text-gray-500">
          <span> Student Support</span>
          <span>/</span>
          <span className="text-black">Service Menu</span>
        </div>

        <div className="flex items-center mt-4 space-x-4">
           <button
              className="flex items-center px-4 py-2  text-[#A8AAAE] rounded-lg shadow hover:bg-[#6C0B67]"
              onClick={() => navigate("/it-services/ims")}
            >
              <CiCirclePlus className="mr-2" />
              IMS
            </button>
          <button
            className="flex items-center px-4 py-2 text-[#A8AAAE] rounded-lg shadow hover:bg-gray-100"
            onClick={() => navigate("/it-services/service-menu")}
          >
            <CiCirclePlus className="mr-2" />
            LMS
          </button>
          <button
            className="flex items-center px-4 py-2 text-[#A8AAAE] rounded-lg shadow hover:bg-gray-100"
            onClick={() => navigate("/it-services/student-portal")}
          >
            <CiCirclePlus className="mr-2" />
            Student Portal
          </button>

          <button
            className="flex items-center px-4 py-2 text-[#A8AAAE] rounded-lg shadow hover:bg-gray-100"
            onClick={() => navigate("/it-services/office")}
          >
            <CiCirclePlus className="mr-2" />
            Office 365
          </button>

          <button
            className="flex items-center px-4 py-2 text-[#A8AAAE] rounded-lg shadow hover:bg-gray-100"
            onClick={() => navigate("/it-services/online-payment")}
          >
            <CiCirclePlus className="mr-2" />
            Online Payments
          </button>

          <button
            className="flex items-center px-4 py-2 text-[#A8AAAE] rounded-lg shadow hover:bg-gray-100"
            onClick={() => navigate("/it-services/password-managment")}
          >
            <CiCirclePlus className="mr-2" />
            Smart Library
          </button>

          <button
            className="flex items-center px-4 py-2 text-white bg-[#92288C] rounded-lg shadow hover:bg-[#6C0B67]"
            onClick={() => navigate("/it-services/help-desk")}
          >
            <CiCirclePlus className="mr-2" />
            IT Help Desk
          </button>
        </div>

        <div className="p-6 mt-6 bg-white rounded-lg shadow-md">
          <h2 className="text-2xl font-bold">Edit Help Desk</h2>
          <form onSubmit={handleUpdate}>
            <div className="mt-6 space-y-4">
              <div>
                <label className="block text-gray-700">Introduction</label>
                <textarea
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                  placeholder="Enter vision message"
                  value={introduction}
                  onChange={(e) => setIntroduction(e.target.value)}
                  style={{ height: "50px", resize: "none" }}
                  required
                />
              </div>
              {/* Supporting Documents (hidden - replaced by Links upload)
              <div>
                <label className="block text-gray-700">
                  Supporting Documents
                </label>
                <div className="flex items-center space-x-4">
                  {fileUrl ? (
                    <>
                      <a
                        href={fileUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-500 underline"
                      >
                        View File
                      </a>
                      <button
                        type="button"
                        className="px-4 py-2 text-red-500 bg-red-100 rounded-md hover:bg-red-200"
                        onClick={handleFileRemove}
                      >
                        Remove
                      </button>
                    </>
                  ) : (
                    <input
                      type="file"
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                      onChange={handleFileChange}
                      required
                    />
                  )}
                </div>
              </div>
              */}

              {/* Link Name */}
              <div>
                <label className="block text-gray-700">Link Name</label>
                <input
                  type="text"
                  placeholder="Name (e.g. IT Support)"
                  value={linkName}
                  onChange={(e) => setLinkName(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                />
              </div>

              {/* Link URL */}
              <div>
                <label className="block text-gray-700">Link URL</label>
                <input
                  type="text"
                  placeholder="URL (e.g. https://example.com)"
                  value={linkUrl}
                  onChange={(e) => setLinkUrl(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                />
              </div>
            </div>
            <div className="flex justify-end mt-6 space-x-4">
              <button
                type="reset"
                className="px-4 py-2 text-[#A8AAAE] bg-gray-200 rounded-md hover:bg-gray-300"
              >
                Clear
              </button>
              <button
                type="submit"
                className="px-4 py-2 text-white bg-[#92288C] rounded-md hover:bg-[#6C0B67]"
              >
                Update
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    </PageComponent></>
  );
}

export default HelpDesk;